import React from "react";
import ConfirmDialog from "../../../popups/ConfirmDialog";

/**
 * MobileConfirmDialog - the vcomp mobile screens' confirm, drawn by the shared ConfirmDialog.
 *
 * @param {boolean} open - Whether the dialog is visible
 * @param {string|ReactNode} header - Dialog title
 * @param {string|ReactNode} message - Confirmation message
 * @param {string|ReactNode} acceptLabel - Accept button label
 * @param {string|ReactNode} rejectLabel - Reject button label (optional; no reject button without it)
 * @param {boolean} danger - a destructive action
 * @param {function} onAccept - Called when accept is clicked
 * @param {function} onReject - Called when reject is clicked (optional)
 * @param {function} onClose - Called when dialog is dismissed
 */
export default function MobileConfirmDialog({
    open,
    header,
    message,
    acceptLabel,
    rejectLabel,
    danger = false,
    onAccept,
    onReject,
    onClose,
}) {
    const handleAccept = () => {
        if (onAccept) onAccept();
        if (onClose) onClose();
    };

    const handleReject = () => {
        if (onReject) onReject();
        if (onClose) onClose();
    };

    return (
        <ConfirmDialog
            open={!!open}
            title={header}
            message={message}
            danger={danger}
            confirmLabel={acceptLabel}
            cancelLabel={rejectLabel}
            hideCancel={!rejectLabel}
            onConfirm={handleAccept}
            onCancel={handleReject}
            onClose={onClose}
        />
    );
}
